<!--
 * @Author: Shber
 * @Date: 2023-02-21 15:20:57
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-16 14:03:54
 * @Description:
-->
<template>
  <div class="mc_markdown">
    <div class="figure_page">
      <div class="inf_con_zt" v-html="content" />
    </div>
  </div>
</template>
<script setup>
import { markdownVideoControl } from '@/utils/index'
import '../style/scss//articles.scss'
import { onMounted, nextTick } from 'vue'
const props = defineProps({
  content: {
    type: String,
    default: ''
  }
})
onMounted(() => {})
nextTick(() => {
  markdownVideoControl()
})

</script>
<style scoped>
  .mc_markdown{padding: 8px;}
</style>
